import { BaseConfig } from '../ServiceConfig';

export interface CatalogConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.CatalogServiceConfigData';
  url: string;
}

export const CatalogConfigurationFields: (keyof CatalogConfiguration)[] = [
  'url',
];

export const BlankCatalogConfiguration: CatalogConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.CatalogServiceConfigData',
} as CatalogConfiguration;
